import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getGadgetTestMigrationStatus = (token, tenantId) => {
    return fetch(`${apiUrl}check_gadget_test_migration_status/${tenantId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });
}

export default getGadgetTestMigrationStatus
